import React, { useState, useEffect } from 'react';
import { MasonryPhotoAlbum } from "react-photo-album";
import { Box, CircularProgress } from '@mui/material';
import { fetchLabLifePhotos, isContentfulConfigured } from '../services/contentful';
import birth from '../images/birthday.webp';
import cafemexico from '../images/Cafe Mexico_2022Jul15.webp';
import cafemexico2 from '../images/cafemexico2.webp';
import elklake from '../images/Elk_Beaver Lake Regional Park_2021Oct10.webp';
import elklake2 from '../images/elklake.webp';
import mnw from '../images/massonnathoowei.webp';
import sooke from '../images/sooke.webp';
import hiking from '../images/hiking.webp';
import dinner from '../images/IMG_4363.jpeg';

const FALLBACK_IMAGES = [
  { src: birth, alt: 'Birthday' },
  { src: cafemexico, alt: 'Cafe Mexico 1' },
  { src: cafemexico2, alt: 'Cafe Mexico 2' },
  { src: elklake, alt: 'Elk Lake 1' },
  { src: elklake2, alt: 'Elk Lake 2' },
  { src: mnw, alt: 'Masson Nathoo Wei' },
  { src: sooke, alt: 'Sooke' },
  { src: hiking, alt: 'Hiking' },
  { src: dinner, alt: 'Dinner' },
];

const loadImageDimensions = (src, alt, title) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = src;
    img.onload = () => resolve({ src, alt, title, width: img.naturalWidth, height: img.naturalHeight });
    img.onerror = () => resolve({ src, alt, title, width: 800, height: 600 });
  });
};

const PhotoGallery = ({ columns = 3 }) => {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadGalleryPhotos = async () => {
      setLoading(true);
      try {
        if (isContentfulConfigured()) {
          const contentfulPhotos = await fetchLabLifePhotos();
          if (contentfulPhotos.length > 0) {
            setPhotos(contentfulPhotos);
            return;
          }
        }
        // Fall back to local images
        const loaded = await Promise.all(
          FALLBACK_IMAGES.map(({ src, alt }) => loadImageDimensions(src, alt, ''))
        );
        setPhotos(loaded);
      } catch (error) {
        console.error('Error loading photos:', error);
      } finally {
        setLoading(false);
      }
    };

    loadGalleryPhotos();
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" py={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (photos.length === 0) {
    return null;
  }

  return (
    <MasonryPhotoAlbum
      photos={photos}
      columns={columns}
    />
  );
};

export default React.memo(PhotoGallery);
